import { UserOrderAPI } from '../../apis/order/UserOrderAPI';

export const UserOrderService = {
  getUserRequests: async () => {
    return await UserOrderAPI.getUserRequests();
  },
};
